import React from 'react';

import cx from 'classnames';

import Icon from 'components/shared/Icon';
import LocIcon from 'components/shared/Icon/icons/Location';

import s from './index.module.css';
import { IWrapper } from './types';

function Wrapper({ children }: IWrapper) {
  return (
    <div className={cx(s.location, 'custom-left-location')}>
      <Icon component={LocIcon} className={cx(s.icon, s.locationIcon, 'custom-left-location-icon')} />
      {children}
    </div>
  );
}

export default Wrapper;
